<template>
  <div class="footer">
    <ul class="links">
      <li><a class="externalLink" target="_blank" :href="links.terms">利用規約</a></li>
      <li><a class="externalLink" target="_blank" :href="links.privacy">プライバシーポリシー</a></li>
      <li @click="gotoSpec">推奨環境</li>
      <li>
        <a class="externalLink" :href="links.official" target="_blank">ぴあアリーナMM</a>
      </li>
    </ul>
    <div class="copyright">
      <img src="../../assets/top/pia-logo.png" alt="">
      <div>
        Copyright © PIA Corporation. All Rights Reserved.
      </div>
    </div>
  </div>
</template>

<script>
import { setPage } from "../../util/StoreUtil";
import * as links from "../../data/Links";
export default {
  name: "Footer",
  methods: {
    gotoSpec() {
      setPage("spec");
    }
  },
  computed: {
    links(){
      return links;
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/common"
div.footer
  border-top: 2px solid #3d4143
  border-bottom: 2px solid #3d4143
  text-align: center
  @include vw(12)
  line-height: 1
.links
  a
    color: white
    text-decoration: none
    &.externalLink
      &:after
        content: ""
        display: inline-block
        background: url("../../assets/footer/link.png") center center no-repeat
        width: 9px
        height: 9px
        background-size: cover
        vertical-align: middle
        margin-top: -3px
        margin-left: 5px

  padding: 22px 0
  background-color: #0c1114
  li
    &:before
      content: ""
      display: inline-block
      background: url("../../assets/footer/arrow.svg") center center no-repeat
      width: 9px
      height: 6px
      margin-right: 6px
      background-size: cover
      vertical-align: middle
      margin-top: -2px

    margin-bottom: 2em
    &:last-child
      margin-bottom: 0

.copyright
  @include flexCenter
  justify-content: space-between
  padding: 20px 3.73%

  img
    @include perW2(162)
    display: block
  @include vw(10)
</style>
